// extracted by mini-css-extract-plugin
module.exports = {"centered":"_1xA66Ha","light":"__5HQbuJ","dark":"_35ZKxnL"};